import { type FieldError, useFormContext } from 'react-hook-form';

/**
 * The error for a field, by path.
 *
 * `formState.errors[name]` only ever resolves a top-level key, so a repeater
 * field named `owners.0.fullName` silently had no error — the input stayed
 * unstyled and the message never rendered. `getFieldState` walks the path
 * properly. Passing `formState` is what subscribes the component to changes.
 */
export function useFieldError(name: string): FieldError | undefined {
  const { getFieldState, formState } = useFormContext();
  return getFieldState(name, formState).error;
}
